import React from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { CommonComponentProps } from '../pages/types';
import { hexToRgb } from './admin/admin-utils';
import EditableMarkdownText from './editable-markdown-text';

interface IngressProps extends CommonComponentProps {
  title?: string;
  paragraph?: string;
  lineColor?: string;
}

const Ingress: React.FC<IngressProps> = ({
  id,
  title = '',
  paragraph = '',
  lineColor = '#000000',
  sx,
  isEditable,
  onPropsChange,
}) => {
  const handleTextChange = (key: keyof IngressProps, value: string) => {
    if (onPropsChange) {
      onPropsChange({ [key]: value });
    }
  };

  return (
    <Box
      id={id}
      sx={{
        maxWidth: '1100px',
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        ...sx,
      }}
    >
      <EditableMarkdownText
        content={title}
        onSave={(val) => handleTextChange('title', val)}
        isEditable={!!isEditable}
        component={Typography}
        typographyVariant="h2"
        sx={{
          textAlign: 'center',
          cursor: isEditable ? 'text' : 'inherit',
        }}
      />
      <Divider
        sx={{
          borderTop: '1px solid #000',
          width: '100%',
          margin: '15px 0px 25px 0px',
          borderColor: lineColor ? `rgba(${hexToRgb(lineColor)}, 0.2)` : '',
        }}
      />
      <EditableMarkdownText
        content={paragraph}
        onSave={(val) => handleTextChange('paragraph', val)}
        isEditable={!!isEditable}
        component={Typography}
        typographyVariant="h4"
        sx={{ cursor: isEditable ? 'text' : 'inherit' }}
      />
    </Box>
  );
};

export default Ingress;
